import { writable } from 'svelte/store'
export const isMobile = writable({ isMob: false })
